import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FiSmartphone } from "react-icons/fi";
import { ApprovalState, cancelApproval, subscribeApproval } from "../../helper/approvals";

function remaining(expiresAt: number): string {
  const s = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** "Approve on your phone" while a protected request waits for the phone (Utils/approvals). */
const ApprovalModal = () => {
  const [state, setState] = useState<ApprovalState | null>(null);
  const [, tick] = useState(0);

  useEffect(() => subscribeApproval(setState), []);
  useEffect(() => {
    if (state?.status !== "waiting") return;
    const t = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, [state]);

  const waiting = state?.status === "waiting";
  return (
    <Modal isOpen={!!state} onClose={cancelApproval} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent mx="16px" borderRadius="12px" data-cy="approval-modal">
        <ModalBody py="24px">
          <VStack spacing={4} textAlign="center">
            <Flex color="primary.500">
              <FiSmartphone size="48px" />
            </Flex>
            <Text fontSize="18px" fontWeight={600}>
              {waiting ? "Approve on your phone" : "Not approved"}
            </Text>
            <Text color="gray.600">{state?.summary}</Text>
            {waiting ? (
              <>
                <Text color="gray.600" fontSize="14px">
                  Open Admiral Access and approve with your fingerprint or Face ID. Expires in{" "}
                  {remaining(state!.expiresAt)}.
                </Text>
                <Spinner color="primary.500" />
              </>
            ) : (
              <Text color="red.500" data-cy="approval-modal-message">
                {state?.message}
              </Text>
            )}
            <Button variant="outline" onClick={cancelApproval} w="full">
              {waiting ? "Cancel" : "Close"}
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ApprovalModal;
